<template>
  <div class="card">
    <div>
      <h1 class="f5 fw5 ma0 pa0 lh-title">
        {{ d.title.main }}
        <span v-if="d.title.secondary" class="fw4 db f6 text-secondary mv1">{{ d.title.secondary }}</span>
      </h1>
    </div>

    <div class="flex flex-row mv3">
      <div class="w-100">
        <div class="tl">
          <span class="f4 f3-ns fw5">{{ d.avg.label }}</span>
          <span class="text-secondary f6 ml2">{{ d.unit }} в среднем</span>
        </div>
        <svg-progress :data="d.progress"></svg-progress>
        <div class="f6 mt1 text-secondary flex justify-between">
          <div>
            {{ d.percent.label }} %
          </div>
          <div>
            макс. {{ d.max.label }} {{ d.unit }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SvgProgress from '@/components/charts/svg/Progress.vue'

export default {
  components: {
    SvgProgress
  },
  props: ['data'],
  computed: {
    d () {
      return {
        title: {
          section: 'Критические показатели',
          main: this.data.title,
          secondary: this.data.subheader
        },
        unit: this.data.unit,
        max: {
          value: this.data.max.value,
          label: this.data.max.value.toLocaleString('ru-RU')
        },
        avg: {
          value: this.data.avg.value,
          label: this.data.avg.value.toLocaleString('ru-RU')
        },
        percent: {
          value: this.data.percent.value,
          label: this.data.percent.value.toFixed(1)
        },
        progress: {
          series: {
            value: this.data.avg.value,
            total: this.data.max.value
          },
          style: {
            color: this.data.avg.style.color
          }
        }
      }
    }
  }
}
</script>
